module.exports = __webpack_public_path__ + "img/Produktbeispiel_6.7e1fe794.jpg";